import styled from 'styled-components';

const getColor = variant => {
  switch (true) {
    case variant?.includes('secondary'):
      return '#6c757d';

    case variant?.includes('primary'):
      return '#007bff';

    case variant?.includes('success'):
      return '#28a745';

    case variant?.includes('warning'):
      return '#ffc107';

    case variant?.includes('danger'):
      return '#dc3545';

    default:
      return '#6c757d';
  }
};

const Badge = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: ${props => props.bg === 'secondary' ? '#6c757d' : 'white'};
  background-color: ${props => getColor(props.bg)};
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
`;
export default Badge;